import { PressResponder } from "@react-aria/interactions";
import { useOverlayTriggerState } from "@react-stately/overlays";
import { Modal, Popover, Tray } from "@react-spectrum/overlays";
import { Heading } from "@react-spectrum/text";
import { Divider } from "@react-spectrum/divider";
import { useMessageFormatter } from "@react-aria/i18n";
import { useDialog } from "@react-aria/dialog";
import { Grid } from "@react-spectrum/layout";
import { FocusScope } from "@react-aria/focus";
import { DismissButton, useOverlayPosition, useOverlayTrigger } from "@react-aria/overlays";
import _react, { useContext, useMemo, useRef, forwardRef, Fragment, useEffect } from "react";
import _spectrumIconsUiCrossLarge from "@spectrum-icons/ui/CrossLarge";
import _babelRuntimeHelpersEsmExtends from "@babel/runtime/helpers/esm/extends";
import { Content } from "@react-spectrum/view";
import { classNames, useStyleProps, SlotProvider, unwrapDOMRef, useDOMRef, useHasChild, useMediaQuery } from "@react-spectrum/utils";
import { chain, mergeProps } from "@react-aria/utils";
import { ButtonGroup } from "@react-spectrum/buttongroup";
import { Button, ActionButton } from "@react-spectrum/button";
import _spectrumIconsUiAlertMedium from "@spectrum-icons/ui/AlertMedium";
import _babelRuntimeHelpersEsmInteropRequireDefault from "@babel/runtime/helpers/esm/interopRequireDefault";
import _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import "./main.css";

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

const $cbd214e8f430cad55f170202f58e419$export$DialogContext = /*#__PURE__*/_react.createContext(null);

// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/components/dialog/vars.css
var $eb3a317262722c9956cb0987c60c4bd$exports = {};
$eb3a317262722c9956cb0987c60c4bd$exports = {
  "spectrum-Dialog": "_spectrum-Dialog_30293",
  "spectrum-Dialog--small": "_spectrum-Dialog--small_30293",
  "spectrum-Dialog--medium": "_spectrum-Dialog--medium_30293",
  "spectrum-Dialog--large": "_spectrum-Dialog--large_30293",
  "spectrum-Dialog-hero": "_spectrum-Dialog-hero_30293",
  "spectrum-Dialog-grid": "_spectrum-Dialog-grid_30293",
  "spectrum-Dialog-heading": "_spectrum-Dialog-heading_30293",
  "spectrum-Dialog-heading--noHeader": "_spectrum-Dialog-heading--noHeader_30293",
  "spectrum-Dialog-header": "_spectrum-Dialog-header_30293",
  "spectrum-Dialog-typeIcon": "_spectrum-Dialog-typeIcon_30293",
  "spectrum-Dialog-divider": "_spectrum-Dialog-divider_30293",
  "spectrum-Dialog--noDivider": "_spectrum-Dialog--noDivider_30293",
  "spectrum-Dialog-content": "_spectrum-Dialog-content_30293",
  "spectrum-Dialog-footer": "_spectrum-Dialog-footer_30293",
  "spectrum-Button": "_spectrum-Button_30293",
  "spectrum-Dialog-buttonGroup": "_spectrum-Dialog-buttonGroup_30293",
  "spectrum-Dialog-buttonGroup--noFooter": "_spectrum-Dialog-buttonGroup--noFooter_30293",
  "spectrum-Dialog--dismissable": "_spectrum-Dialog--dismissable_30293",
  "spectrum-Dialog-closeButton": "_spectrum-Dialog-closeButton_30293",
  "spectrum-Dialog--error": "_spectrum-Dialog--error_30293",
  "spectrum-Dialog--fullscreen": "_spectrum-Dialog--fullscreen_30293",
  "spectrum-Dialog--fullscreenTakeover": "_spectrum-Dialog--fullscreenTakeover_30293",
  "spectrum-Dialog--warning": "_spectrum-Dialog--warning_30293"
};
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/ar-AE.json
var $cda3171330b3a3f16d0b2a83481b7$exports = {};
$cda3171330b3a3f16d0b2a83481b7$exports = JSON.parse("{\"alert\":\"تنبيه\",\"dismiss\":\"تجاهل\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/bg-BG.json
var $f8a546383e13d32df838c745203525ed$exports = {};
$f8a546383e13d32df838c745203525ed$exports = JSON.parse("{\"alert\":\"Сигнал\",\"dismiss\":\"Отхвърляне\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/cs-CZ.json
var $ec50406db96942e47f23d588239c0d65$exports = {};
$ec50406db96942e47f23d588239c0d65$exports = JSON.parse("{\"alert\":\"Výstraha\",\"dismiss\":\"Odstranit\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/da-DK.json
var $e070bca5cea346ecd3fc2fe3dcdd9$exports = {};
$e070bca5cea346ecd3fc2fe3dcdd9$exports = JSON.parse("{\"alert\":\"Advarsel\",\"dismiss\":\"Luk\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/de-DE.json
var $c1581ca19f0b58cac1ef8bdc545359d2$exports = {};
$c1581ca19f0b58cac1ef8bdc545359d2$exports = JSON.parse("{\"alert\":\"Warnhinweis\",\"dismiss\":\"Schließen\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/el-GR.json
var $b0d4b83dc06d1800aa3833395a270eb$exports = {};
$b0d4b83dc06d1800aa3833395a270eb$exports = JSON.parse("{\"alert\":\"Ειδοποίηση\",\"dismiss\":\"Απόρριψη\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/en-US.json
var $ad57de82ed66d86ee00fe5b33f70d9cc$exports = {};
$ad57de82ed66d86ee00fe5b33f70d9cc$exports = JSON.parse("{\"dismiss\":\"Dismiss\",\"alert\":\"Alert\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/es-ES.json
var $b682386a7bb26bf7e3d38718615422e5$exports = {};
$b682386a7bb26bf7e3d38718615422e5$exports = JSON.parse("{\"alert\":\"Alerta\",\"dismiss\":\"Descartar\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/et-EE.json
var $b6f67490f517e54af6ee1123d12dd99f$exports = {};
$b6f67490f517e54af6ee1123d12dd99f$exports = JSON.parse("{\"alert\":\"Teade\",\"dismiss\":\"Lõpeta\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/fi-FI.json
var $f15a91d97e746d6a880633ccbeffb0b$exports = {};
$f15a91d97e746d6a880633ccbeffb0b$exports = JSON.parse("{\"alert\":\"Hälytys\",\"dismiss\":\"Hylkää\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/fr-FR.json
var $da8026cc0428c4ad990f78c5c983$exports = {};
$da8026cc0428c4ad990f78c5c983$exports = JSON.parse("{\"alert\":\"Alerte\",\"dismiss\":\"Rejeter\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/he-IL.json
var $f57e9cdb12153854ba519a55485ad5a9$exports = {};
$f57e9cdb12153854ba519a55485ad5a9$exports = JSON.parse("{\"alert\":\"התראה\",\"dismiss\":\"התעלם\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/hr-HR.json
var $ac4fb0d642e0c39de2d39f84420c$exports = {};
$ac4fb0d642e0c39de2d39f84420c$exports = JSON.parse("{\"alert\":\"Upozorenje\",\"dismiss\":\"Odbaci\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/hu-HU.json
var $caba5001fea6351ab3cf41adf8816601$exports = {};
$caba5001fea6351ab3cf41adf8816601$exports = JSON.parse("{\"alert\":\"Figyelmeztetés\",\"dismiss\":\"Elutasítás\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/it-IT.json
var $d539ed71634a71c0f459986c39bcd6$exports = {};
$d539ed71634a71c0f459986c39bcd6$exports = JSON.parse("{\"alert\":\"Avviso\",\"dismiss\":\"Ignora\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/ja-JP.json
var $a3fed196c23398fed03beaccb9669$exports = {};
$a3fed196c23398fed03beaccb9669$exports = JSON.parse("{\"alert\":\"アラート\",\"dismiss\":\"閉じる\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/ko-KR.json
var $b512d7f38abf726193a10edcb1dcaeb5$exports = {};
$b512d7f38abf726193a10edcb1dcaeb5$exports = JSON.parse("{\"alert\":\"경고\",\"dismiss\":\"무시\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/lt-LT.json
var $a4beeddccd1bcede8b049d31feb45202$exports = {};
$a4beeddccd1bcede8b049d31feb45202$exports = JSON.parse("{\"alert\":\"Įspėjimas\",\"dismiss\":\"Atmesti\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/lv-LV.json
var $f78977a654b81b471bf97a6e22b$exports = {};
$f78977a654b81b471bf97a6e22b$exports = JSON.parse("{\"alert\":\"Brīdinājums\",\"dismiss\":\"Nerādīt\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/nb-NO.json
var $ef3f286f561408a9808a5bc3b312$exports = {};
$ef3f286f561408a9808a5bc3b312$exports = JSON.parse("{\"alert\":\"Varsel\",\"dismiss\":\"Lukk\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/nl-NL.json
var $d1aa1729504fe6307a914a54107e776$exports = {};
$d1aa1729504fe6307a914a54107e776$exports = JSON.parse("{\"alert\":\"Melding\",\"dismiss\":\"Negeren\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/pl-PL.json
var $d7a228555cf43ed08a2839d375adce1$exports = {};
$d7a228555cf43ed08a2839d375adce1$exports = JSON.parse("{\"alert\":\"Ostrzeżenie\",\"dismiss\":\"Zignoruj\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/pt-BR.json
var $ef927e73c83dd439d30c8225d25488f4$exports = {};
$ef927e73c83dd439d30c8225d25488f4$exports = JSON.parse("{\"alert\":\"Alerta\",\"dismiss\":\"Descartar\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/pt-PT.json
var $e4abc4f2515e6bed1636ba9978d44ec$exports = {};
$e4abc4f2515e6bed1636ba9978d44ec$exports = JSON.parse("{\"alert\":\"Alerta\",\"dismiss\":\"Dispensar\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/ro-RO.json
var $ce5caf72a6eb47671da9080157805a98$exports = {};
$ce5caf72a6eb47671da9080157805a98$exports = JSON.parse("{\"alert\":\"Alertă\",\"dismiss\":\"Revocare\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/ru-RU.json
var $f409a6ec85597c5eed17239295205b1$exports = {};
$f409a6ec85597c5eed17239295205b1$exports = JSON.parse("{\"alert\":\"Предупреждение\",\"dismiss\":\"Пропустить\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/sk-SK.json
var $cb15d97285a490b12c188179c2163db9$exports = {};
$cb15d97285a490b12c188179c2163db9$exports = JSON.parse("{\"alert\":\"Upozornenie\",\"dismiss\":\"Zrušiť\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/sl-SI.json
var $df3ac31524464bd03fcb50be18c4fd3$exports = {};
$df3ac31524464bd03fcb50be18c4fd3$exports = JSON.parse("{\"alert\":\"Opozorilo\",\"dismiss\":\"Opusti\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/sr-SP.json
var $b09f3d9c71714c6a0ee7ae587b3485$exports = {};
$b09f3d9c71714c6a0ee7ae587b3485$exports = JSON.parse("{\"alert\":\"Upozorenje\",\"dismiss\":\"Odbaci\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/sv-SE.json
var $f8ebf8c54efd9dbff5f4a64dd1209e84$exports = {};
$f8ebf8c54efd9dbff5f4a64dd1209e84$exports = JSON.parse("{\"alert\":\"Varning\",\"dismiss\":\"Avvisa\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/tr-TR.json
var $b4867fd7c767e2d8b7b5789d7122f039$exports = {};
$b4867fd7c767e2d8b7b5789d7122f039$exports = JSON.parse("{\"alert\":\"Uyarı\",\"dismiss\":\"Kapat\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/uk-UA.json
var $f987f6bd2430c661be784240877c73f5$exports = {};
$f987f6bd2430c661be784240877c73f5$exports = JSON.parse("{\"alert\":\"Сигнал тривоги\",\"dismiss\":\"Скасувати\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/zh-CN.json
var $cb2972e86dd686f180a66bde8589dd3$exports = {};
$cb2972e86dd686f180a66bde8589dd3$exports = JSON.parse("{\"alert\":\"警报\",\"dismiss\":\"取消\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/zh-TW.json
var $e0d5d27acc364e9b31fcd8bf005557d$exports = {};
$e0d5d27acc364e9b31fcd8bf005557d$exports = JSON.parse("{\"alert\":\"警示\",\"dismiss\":\"關閉\"}");
// @ts-ignore
const $ae0ae5ec87ff1f7a54fe4ae25e$var$intlMessages = {
  "ar-AE": _babelRuntimeHelpersEsmInteropRequireDefault($cda3171330b3a3f16d0b2a83481b7$exports).default,
  "bg-BG": _babelRuntimeHelpersEsmInteropRequireDefault($f8a546383e13d32df838c745203525ed$exports).default,
  "cs-CZ": _babelRuntimeHelpersEsmInteropRequireDefault($ec50406db96942e47f23d588239c0d65$exports).default,
  "da-DK": _babelRuntimeHelpersEsmInteropRequireDefault($e070bca5cea346ecd3fc2fe3dcdd9$exports).default,
  "de-DE": _babelRuntimeHelpersEsmInteropRequireDefault($c1581ca19f0b58cac1ef8bdc545359d2$exports).default,
  "el-GR": _babelRuntimeHelpersEsmInteropRequireDefault($b0d4b83dc06d1800aa3833395a270eb$exports).default,
  "en-US": _babelRuntimeHelpersEsmInteropRequireDefault($ad57de82ed66d86ee00fe5b33f70d9cc$exports).default,
  "es-ES": _babelRuntimeHelpersEsmInteropRequireDefault($b682386a7bb26bf7e3d38718615422e5$exports).default,
  "et-EE": _babelRuntimeHelpersEsmInteropRequireDefault($b6f67490f517e54af6ee1123d12dd99f$exports).default,
  "fi-FI": _babelRuntimeHelpersEsmInteropRequireDefault($f15a91d97e746d6a880633ccbeffb0b$exports).default,
  "fr-FR": _babelRuntimeHelpersEsmInteropRequireDefault($da8026cc0428c4ad990f78c5c983$exports).default,
  "he-IL": _babelRuntimeHelpersEsmInteropRequireDefault($f57e9cdb12153854ba519a55485ad5a9$exports).default,
  "hr-HR": _babelRuntimeHelpersEsmInteropRequireDefault($ac4fb0d642e0c39de2d39f84420c$exports).default,
  "hu-HU": _babelRuntimeHelpersEsmInteropRequireDefault($caba5001fea6351ab3cf41adf8816601$exports).default,
  "it-IT": _babelRuntimeHelpersEsmInteropRequireDefault($d539ed71634a71c0f459986c39bcd6$exports).default,
  "ja-JP": _babelRuntimeHelpersEsmInteropRequireDefault($a3fed196c23398fed03beaccb9669$exports).default,
  "ko-KR": _babelRuntimeHelpersEsmInteropRequireDefault($b512d7f38abf726193a10edcb1dcaeb5$exports).default,
  "lt-LT": _babelRuntimeHelpersEsmInteropRequireDefault($a4beeddccd1bcede8b049d31feb45202$exports).default,
  "lv-LV": _babelRuntimeHelpersEsmInteropRequireDefault($f78977a654b81b471bf97a6e22b$exports).default,
  "nb-NO": _babelRuntimeHelpersEsmInteropRequireDefault($ef3f286f561408a9808a5bc3b312$exports).default,
  "nl-NL": _babelRuntimeHelpersEsmInteropRequireDefault($d1aa1729504fe6307a914a54107e776$exports).default,
  "pl-PL": _babelRuntimeHelpersEsmInteropRequireDefault($d7a228555cf43ed08a2839d375adce1$exports).default,
  "pt-BR": _babelRuntimeHelpersEsmInteropRequireDefault($ef927e73c83dd439d30c8225d25488f4$exports).default,
  "pt-PT": _babelRuntimeHelpersEsmInteropRequireDefault($e4abc4f2515e6bed1636ba9978d44ec$exports).default,
  "ro-RO": _babelRuntimeHelpersEsmInteropRequireDefault($ce5caf72a6eb47671da9080157805a98$exports).default,
  "ru-RU": _babelRuntimeHelpersEsmInteropRequireDefault($f409a6ec85597c5eed17239295205b1$exports).default,
  "sk-SK": _babelRuntimeHelpersEsmInteropRequireDefault($cb15d97285a490b12c188179c2163db9$exports).default,
  "sl-SI": _babelRuntimeHelpersEsmInteropRequireDefault($df3ac31524464bd03fcb50be18c4fd3$exports).default,
  "sr-SP": _babelRuntimeHelpersEsmInteropRequireDefault($b09f3d9c71714c6a0ee7ae587b3485$exports).default,
  "sv-SE": _babelRuntimeHelpersEsmInteropRequireDefault($f8ebf8c54efd9dbff5f4a64dd1209e84$exports).default,
  "tr-TR": _babelRuntimeHelpersEsmInteropRequireDefault($b4867fd7c767e2d8b7b5789d7122f039$exports).default,
  "uk-UA": _babelRuntimeHelpersEsmInteropRequireDefault($f987f6bd2430c661be784240877c73f5$exports).default,
  "zh-CN": _babelRuntimeHelpersEsmInteropRequireDefault($cb2972e86dd686f180a66bde8589dd3$exports).default,
  "zh-TW": _babelRuntimeHelpersEsmInteropRequireDefault($e0d5d27acc364e9b31fcd8bf005557d$exports).default
};
let $ae0ae5ec87ff1f7a54fe4ae25e$var$sizeMap = {
  S: 'small',
  M: 'medium',
  L: 'large',
  fullscreen: 'fullscreen',
  fullscreenTakeover: 'fullscreenTakeover'
};
var $eb3a317262722c9956cb0987c60c4bd$$interop$default = $parcel$interopDefault($eb3a317262722c9956cb0987c60c4bd$exports);

function $ae0ae5ec87ff1f7a54fe4ae25e$var$Dialog(props, ref) {
  let _ref = useContext($cbd214e8f430cad55f170202f58e419$export$DialogContext) || {},
      {
    type = 'modal'
  } = _ref,
      contextProps = _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose(_ref, ["type"]);

  let {
    children,
    isDismissable = contextProps.isDismissable,
    onDismiss = contextProps.onClose,
    size
  } = props,
      otherProps = _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose(props, ["children", "isDismissable", "onDismiss", "size"]);

  let formatMessage = useMessageFormatter($ae0ae5ec87ff1f7a54fe4ae25e$var$intlMessages);
  let {
    styleProps
  } = useStyleProps(otherProps);
  size = type === 'popover' ? size || 'S' : size || 'L';
  let domRef = useDOMRef(ref);
  let gridRef = useRef();
  let sizeVariant = $ae0ae5ec87ff1f7a54fe4ae25e$var$sizeMap[type] || $ae0ae5ec87ff1f7a54fe4ae25e$var$sizeMap[size];
  let {
    dialogProps,
    titleProps
  } = useDialog(mergeProps(contextProps, props), domRef);
  let hasHeader = useHasChild("." + $eb3a317262722c9956cb0987c60c4bd$$interop$default['spectrum-Dialog-header'], unwrapDOMRef(gridRef));
  let hasFooter = useHasChild("." + $eb3a317262722c9956cb0987c60c4bd$$interop$default['spectrum-Dialog-footer'], unwrapDOMRef(gridRef));
  let slots = useMemo(() => ({
    hero: {
      UNSAFE_className: $eb3a317262722c9956cb0987c60c4bd$$interop$default['spectrum-Dialog-hero']
    },
    header: {
      UNSAFE_className: $eb3a317262722c9956cb0987c60c4bd$$interop$default['spectrum-Dialog-header']
    },
    heading: _babelRuntimeHelpersEsmExtends({
      UNSAFE_className: classNames($eb3a317262722c9956cb0987c60c4bd$$interop$default, 'spectrum-Dialog-heading', {
        'spectrum-Dialog-heading--noHeader': !hasHeader
      })
    }, titleProps),
    typeIcon: {
      UNSAFE_className: $eb3a317262722c9956cb0987c60c4bd$$interop$default['spectrum-Dialog-typeIcon']
    },
    divider: {
      UNSAFE_className: $eb3a317262722c9956cb0987c60c4bd$$interop$default['spectrum-Dialog-divider'],
      size: 'M'
    },
    content: {
      UNSAFE_className: $eb3a317262722c9956cb0987c60c4bd$$interop$default['spectrum-Dialog-content']
    },
    footer: {
      UNSAFE_className: $eb3a317262722c9956cb0987c60c4bd$$interop$default['spectrum-Dialog-footer']
    },
    buttonGroup: {
      UNSAFE_className: classNames($eb3a317262722c9956cb0987c60c4bd$$interop$default, 'spectrum-Dialog-buttonGroup', {
        'spectrum-Dialog-buttonGroup--noFooter': !hasFooter
      }),
      align: 'end'
    }
  }), [$eb3a317262722c9956cb0987c60c4bd$$interop$default, hasFooter, hasHeader, titleProps]); // If rendered in a popover or tray there won't be a visible dismiss button,
  // so we render a hidden one for screen readers.

  let dismissButton;

  if (type === 'popover' || type === 'tray') {
    dismissButton = /*#__PURE__*/_react.createElement(DismissButton, {
      onDismiss: onDismiss
    });
  }

  return /*#__PURE__*/_react.createElement(FocusScope, {
    contain: true,
    restoreFocus: true
  }, /*#__PURE__*/_react.createElement("section", _babelRuntimeHelpersEsmExtends({}, styleProps, dialogProps, {
    className: classNames($eb3a317262722c9956cb0987c60c4bd$$interop$default, 'spectrum-Dialog', {
      ["spectrum-Dialog--" + sizeVariant]: sizeVariant,
      'spectrum-Dialog--dismissable': isDismissable
    }, styleProps.className),
    ref: domRef
  }), /*#__PURE__*/_react.createElement(Grid, {
    ref: gridRef,
    UNSAFE_className: $eb3a317262722c9956cb0987c60c4bd$$interop$default['spectrum-Dialog-grid']
  }, /*#__PURE__*/_react.createElement(SlotProvider, {
    slots: slots
  }, children), isDismissable && /*#__PURE__*/_react.createElement(ActionButton, {
    UNSAFE_className: $eb3a317262722c9956cb0987c60c4bd$$interop$default['spectrum-Dialog-closeButton'],
    isQuiet: true,
    "aria-label": formatMessage('dismiss'),
    onPress: onDismiss
  }, /*#__PURE__*/_react.createElement(_spectrumIconsUiCrossLarge, null))), dismissButton));
}
/**
 * Dialogs are windows containing contextual information, tasks, or workflows that appear over the user interface.
 * Depending on the kind of Dialog, further interactions may be blocked until the Dialog is acknowledged.
 */


export let Dialog = /*#__PURE__*/_react.forwardRef($ae0ae5ec87ff1f7a54fe4ae25e$var$Dialog);
// @ts-ignore
const $a3dd0910feda015a44956582ca4d4997$var$intlMessages = {
  "ar-AE": _babelRuntimeHelpersEsmInteropRequireDefault($cda3171330b3a3f16d0b2a83481b7$exports).default,
  "bg-BG": _babelRuntimeHelpersEsmInteropRequireDefault($f8a546383e13d32df838c745203525ed$exports).default,
  "cs-CZ": _babelRuntimeHelpersEsmInteropRequireDefault($ec50406db96942e47f23d588239c0d65$exports).default,
  "da-DK": _babelRuntimeHelpersEsmInteropRequireDefault($e070bca5cea346ecd3fc2fe3dcdd9$exports).default,
  "de-DE": _babelRuntimeHelpersEsmInteropRequireDefault($c1581ca19f0b58cac1ef8bdc545359d2$exports).default,
  "el-GR": _babelRuntimeHelpersEsmInteropRequireDefault($b0d4b83dc06d1800aa3833395a270eb$exports).default,
  "en-US": _babelRuntimeHelpersEsmInteropRequireDefault($ad57de82ed66d86ee00fe5b33f70d9cc$exports).default,
  "es-ES": _babelRuntimeHelpersEsmInteropRequireDefault($b682386a7bb26bf7e3d38718615422e5$exports).default,
  "et-EE": _babelRuntimeHelpersEsmInteropRequireDefault($b6f67490f517e54af6ee1123d12dd99f$exports).default,
  "fi-FI": _babelRuntimeHelpersEsmInteropRequireDefault($f15a91d97e746d6a880633ccbeffb0b$exports).default,
  "fr-FR": _babelRuntimeHelpersEsmInteropRequireDefault($da8026cc0428c4ad990f78c5c983$exports).default,
  "he-IL": _babelRuntimeHelpersEsmInteropRequireDefault($f57e9cdb12153854ba519a55485ad5a9$exports).default,
  "hr-HR": _babelRuntimeHelpersEsmInteropRequireDefault($ac4fb0d642e0c39de2d39f84420c$exports).default,
  "hu-HU": _babelRuntimeHelpersEsmInteropRequireDefault($caba5001fea6351ab3cf41adf8816601$exports).default,
  "it-IT": _babelRuntimeHelpersEsmInteropRequireDefault($d539ed71634a71c0f459986c39bcd6$exports).default,
  "ja-JP": _babelRuntimeHelpersEsmInteropRequireDefault($a3fed196c23398fed03beaccb9669$exports).default,
  "ko-KR": _babelRuntimeHelpersEsmInteropRequireDefault($b512d7f38abf726193a10edcb1dcaeb5$exports).default,
  "lt-LT": _babelRuntimeHelpersEsmInteropRequireDefault($a4beeddccd1bcede8b049d31feb45202$exports).default,
  "lv-LV": _babelRuntimeHelpersEsmInteropRequireDefault($f78977a654b81b471bf97a6e22b$exports).default,
  "nb-NO": _babelRuntimeHelpersEsmInteropRequireDefault($ef3f286f561408a9808a5bc3b312$exports).default,
  "nl-NL": _babelRuntimeHelpersEsmInteropRequireDefault($d1aa1729504fe6307a914a54107e776$exports).default,
  "pl-PL": _babelRuntimeHelpersEsmInteropRequireDefault($d7a228555cf43ed08a2839d375adce1$exports).default,
  "pt-BR": _babelRuntimeHelpersEsmInteropRequireDefault($ef927e73c83dd439d30c8225d25488f4$exports).default,
  "pt-PT": _babelRuntimeHelpersEsmInteropRequireDefault($e4abc4f2515e6bed1636ba9978d44ec$exports).default,
  "ro-RO": _babelRuntimeHelpersEsmInteropRequireDefault($ce5caf72a6eb47671da9080157805a98$exports).default,
  "ru-RU": _babelRuntimeHelpersEsmInteropRequireDefault($f409a6ec85597c5eed17239295205b1$exports).default,
  "sk-SK": _babelRuntimeHelpersEsmInteropRequireDefault($cb15d97285a490b12c188179c2163db9$exports).default,
  "sl-SI": _babelRuntimeHelpersEsmInteropRequireDefault($df3ac31524464bd03fcb50be18c4fd3$exports).default,
  "sr-SP": _babelRuntimeHelpersEsmInteropRequireDefault($b09f3d9c71714c6a0ee7ae587b3485$exports).default,
  "sv-SE": _babelRuntimeHelpersEsmInteropRequireDefault($f8ebf8c54efd9dbff5f4a64dd1209e84$exports).default,
  "tr-TR": _babelRuntimeHelpersEsmInteropRequireDefault($b4867fd7c767e2d8b7b5789d7122f039$exports).default,
  "uk-UA": _babelRuntimeHelpersEsmInteropRequireDefault($f987f6bd2430c661be784240877c73f5$exports).default,
  "zh-CN": _babelRuntimeHelpersEsmInteropRequireDefault($cb2972e86dd686f180a66bde8589dd3$exports).default,
  "zh-TW": _babelRuntimeHelpersEsmInteropRequireDefault($e0d5d27acc364e9b31fcd8bf005557d$exports).default
};

/**
 * AlertDialogs are a specific type of Dialog. They display important information that users need to acknowledge.
 */
function $a3dd0910feda015a44956582ca4d4997$var$AlertDialog(props, ref) {
  let {
    onClose = () => {}
  } = useContext($cbd214e8f430cad55f170202f58e419$export$DialogContext) || {};

  let {
    variant,
    children,
    primaryActionLabel,
    secondaryActionLabel,
    cancelLabel,
    autoFocusButton,
    title,
    isPrimaryActionDisabled,
    isSecondaryActionDisabled,
    onCancel = () => {},
    onPrimaryAction = () => {},
    onSecondaryAction = () => {}
  } = props,
      otherProps = _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose(props, ["variant", "children", "primaryActionLabel", "secondaryActionLabel", "cancelLabel", "autoFocusButton", "title", "isPrimaryActionDisabled", "isSecondaryActionDisabled", "onCancel", "onPrimaryAction", "onSecondaryAction"]);

  let {
    styleProps
  } = useStyleProps(otherProps);
  let formatMessage = useMessageFormatter($a3dd0910feda015a44956582ca4d4997$var$intlMessages);
  let confirmVariant = 'primary';

  if (variant) {
    if (variant === 'confirmation') {
      confirmVariant = 'cta';
    } else if (variant === 'destructive') {
      confirmVariant = 'negative';
    }
  }

  return /*#__PURE__*/_react.createElement(Dialog, {
    UNSAFE_style: styleProps.style,
    UNSAFE_className: classNames($eb3a317262722c9956cb0987c60c4bd$$interop$default, {
      ["spectrum-Dialog--" + variant]: variant
    }, styleProps.className),
    isHidden: styleProps.hidden,
    size: "M",
    role: "alertdialog",
    ref: ref
  }, /*#__PURE__*/_react.createElement(Heading, null, title), (variant === 'error' || variant === 'warning') && /*#__PURE__*/_react.createElement(_spectrumIconsUiAlertMedium, {
    slot: "typeIcon",
    "aria-label": formatMessage('alert')
  }), /*#__PURE__*/_react.createElement(Divider, null), /*#__PURE__*/_react.createElement(Content, null, children), /*#__PURE__*/_react.createElement(ButtonGroup, {
    align: "end"
  }, cancelLabel && /*#__PURE__*/_react.createElement(Button, {
    variant: "secondary",
    onPress: () => chain(onClose(), onCancel()),
    autoFocus: autoFocusButton === 'cancel'
  }, cancelLabel), secondaryActionLabel && /*#__PURE__*/_react.createElement(Button, {
    variant: "secondary",
    onPress: () => chain(onClose(), onSecondaryAction()),
    isDisabled: isSecondaryActionDisabled,
    autoFocus: autoFocusButton === 'secondary'
  }, secondaryActionLabel), /*#__PURE__*/_react.createElement(Button, {
    variant: confirmVariant,
    onPress: () => chain(onClose(), onPrimaryAction()),
    isDisabled: isPrimaryActionDisabled,
    autoFocus: autoFocusButton === 'primary'
  }, primaryActionLabel)));
}
/**
 * AlertDialogs are a specific type of Dialog. They display important information that users need to acknowledge.
 */


export let AlertDialog = /*#__PURE__*/forwardRef($a3dd0910feda015a44956582ca4d4997$var$AlertDialog);

function $b3e9aa84487f353b5d43baaa685254c$var$DialogTrigger(props) {
  let {
    children,
    type = 'modal',
    mobileType = type === 'popover' ? 'modal' : type,
    hideArrow,
    targetRef,
    isDismissable,
    isKeyboardDismissDisabled
  } = props,
      positionProps = _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose(props, ["children", "type", "mobileType", "hideArrow", "targetRef", "isDismissable", "isKeyboardDismissDisabled"]);

  if (!Array.isArray(children) || children.length > 2) {
    throw new Error('DialogTrigger must have exactly 2 children');
  } // if a function is passed as the second child, it won't appear in toArray


  let [trigger, content] = children; // On small devices, show a modal or tray instead of a popover.
  // TODO: DNA variable?

  let isMobile = useMediaQuery('(max-width: 700px)');

  if (isMobile) {
    // handle cases where desktop popovers need a close button for the mobile modal view
    if (type !== 'modal' && mobileType === 'modal') {
      isDismissable = true;
    }

    type = mobileType;
  }

  let state = useOverlayTriggerState(props);
  let wasOpen = useRef(false);
  wasOpen.current = state.isOpen;
  let isExiting = useRef(false);

  let onExiting = () => isExiting.current = true;

  let onExited = () => isExiting.current = false; // eslint-disable-next-line arrow-body-style


  useEffect(() => {
    return () => {
      if ((wasOpen.current || isExiting.current) && type !== 'popover' && type !== 'tray') {
        console.warn('A DialogTrigger unmounted while open. This is likely due to being placed within a trigger that unmounts or inside a conditional. Consider using a DialogContainer instead.');
      }
    };
  }, []);

  if (type === 'popover') {
    return /*#__PURE__*/_react.createElement($b3e9aa84487f353b5d43baaa685254c$var$PopoverTrigger, _babelRuntimeHelpersEsmExtends({}, positionProps, {
      state: state,
      targetRef: targetRef,
      trigger: trigger,
      content: content,
      isKeyboardDismissDisabled: isKeyboardDismissDisabled,
      hideArrow: hideArrow
    }));
  }

  let renderOverlay = () => {
    switch (type) {
      case 'fullscreen':
      case 'fullscreenTakeover':
      case 'modal':
        return /*#__PURE__*/_react.createElement(Modal, {
          isOpen: state.isOpen,
          isDismissable: type === 'modal' ? isDismissable : false,
          onClose: state.close,
          type: type,
          isKeyboardDismissDisabled: isKeyboardDismissDisabled,
          onExiting: onExiting,
          onExited: onExited
        }, typeof content === 'function' ? content(state.close) : content);

      case 'tray':
        return /*#__PURE__*/_react.createElement(Tray, {
          isOpen: state.isOpen,
          onClose: state.close,
          isKeyboardDismissDisabled: isKeyboardDismissDisabled
        }, typeof content === 'function' ? content(state.close) : content);
    }
  };

  return /*#__PURE__*/_react.createElement($b3e9aa84487f353b5d43baaa685254c$var$DialogTriggerBase, {
    type: type,
    state: state,
    isDismissable: isDismissable,
    trigger: trigger,
    overlay: renderOverlay()
  });
} // Support DialogTrigger inside components using CollectionBuilder.


$b3e9aa84487f353b5d43baaa685254c$var$DialogTrigger.getCollectionNode = function* (props) {
  let [trigger] = _react.Children.toArray(props.children);

  let [, content] = props.children;
  yield {
    element: trigger,
    wrapper: element => /*#__PURE__*/_react.createElement($b3e9aa84487f353b5d43baaa685254c$var$DialogTrigger, _babelRuntimeHelpersEsmExtends({
      key: element.key
    }, props), element, content)
  };
};
/**
 * DialogTrigger serves as a wrapper around a Dialog and its associated trigger, linking the Dialog's
 * open state with the trigger's press state. Additionally, it allows you to customize the type and
 * positioning of the Dialog.
 */
// We don't want getCollectionNode to show up in the type definition


export let DialogTrigger = $b3e9aa84487f353b5d43baaa685254c$var$DialogTrigger;

function $b3e9aa84487f353b5d43baaa685254c$var$PopoverTrigger(_ref) {
  let {
    state,
    targetRef,
    trigger,
    content,
    hideArrow,
    isKeyboardDismissDisabled
  } = _ref,
      props = _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose(_ref, ["state", "targetRef", "trigger", "content", "hideArrow", "isKeyboardDismissDisabled"]);

  let triggerRef = useRef();
  let overlayRef = useRef();
  let {
    overlayProps: popoverProps,
    placement,
    arrowProps
  } = useOverlayPosition({
    targetRef: targetRef || triggerRef,
    overlayRef: unwrapDOMRef(overlayRef),
    placement: props.placement,
    containerPadding: props.containerPadding,
    offset: props.offset,
    crossOffset: props.crossOffset,
    shouldFlip: props.shouldFlip,
    isOpen: state.isOpen
  });
  let {
    triggerProps,
    overlayProps
  } = useOverlayTrigger({
    type: 'dialog'
  }, state, triggerRef);

  let triggerPropsWithRef = _babelRuntimeHelpersEsmExtends({}, triggerProps, {
    ref: targetRef ? undefined : triggerRef
  });

  let overlay = /*#__PURE__*/_react.createElement(Popover, {
    isOpen: state.isOpen,
    UNSAFE_style: popoverProps.style,
    ref: overlayRef,
    onClose: state.close,
    placement: placement,
    arrowProps: arrowProps,
    isKeyboardDismissDisabled: isKeyboardDismissDisabled,
    hideArrow: hideArrow
  }, typeof content === 'function' ? content(state.close) : content);

  return /*#__PURE__*/_react.createElement($b3e9aa84487f353b5d43baaa685254c$var$DialogTriggerBase, {
    type: "popover",
    state: state,
    triggerProps: triggerPropsWithRef,
    dialogProps: overlayProps,
    trigger: trigger,
    overlay: overlay
  });
}

function $b3e9aa84487f353b5d43baaa685254c$var$DialogTriggerBase(_ref2) {
  let {
    type,
    state,
    isDismissable,
    dialogProps = {},
    triggerProps = {},
    overlay,
    trigger
  } = _ref2;

  let context = _babelRuntimeHelpersEsmExtends({
    type,
    onClose: state.close,
    isDismissable
  }, dialogProps);

  return /*#__PURE__*/_react.createElement(Fragment, null, /*#__PURE__*/_react.createElement(PressResponder, _babelRuntimeHelpersEsmExtends({}, triggerProps, {
    onPress: state.toggle,
    isPressed: state.isOpen && type !== 'modal' && type !== 'fullscreen' && type !== 'fullscreenTakeover'
  }), trigger), /*#__PURE__*/_react.createElement($cbd214e8f430cad55f170202f58e419$export$DialogContext.Provider, {
    value: context
  }, overlay));
}

/**
 * A DialogContainer accepts a single Dialog as a child, and manages showing and hiding
 * it in a modal. Useful in cases where there is no trigger element
 * or when the trigger unmounts while the dialog is open.
 */
export function DialogContainer(props) {
  let {
    children,
    type = 'modal',
    onDismiss,
    isDismissable,
    isKeyboardDismissDisabled
  } = props;

  let childArray = _react.Children.toArray(children);

  if (childArray.length > 1) {
    throw new Error('Only a single child can be passed to DialogContainer.');
  }

  let lastChild = useRef(null);
  let child = /*#__PURE__*/_react.isValidElement(childArray[0]) ? childArray[0] : null;

  if (child) {
    lastChild.current = child;
  }

  let context = {
    type,
    onClose: onDismiss,
    isDismissable
  };
  return /*#__PURE__*/_react.createElement(Modal, {
    isOpen: !!child,
    onClose: onDismiss,
    type: type,
    isDismissable: isDismissable,
    isKeyboardDismissDisabled: isKeyboardDismissDisabled
  }, /*#__PURE__*/_react.createElement($cbd214e8f430cad55f170202f58e419$export$DialogContext.Provider, {
    value: context
  }, lastChild.current));
}
export function useDialogContainer() {
  let context = useContext($cbd214e8f430cad55f170202f58e419$export$DialogContext);

  if (!context) {
    throw new Error('Cannot call useDialogContext outside a <DialogTrigger> or <DialogContainer>.');
  }

  return {
    type: context.type,

    dismiss() {
      context.onClose();
    }

  };
}
//# sourceMappingURL=module.js.map
